export default "__VITE_ASSET__b78f38f4__"